(function() {
  function initPrebundle(root) {
    if (!root || root.dataset.jciWagonPrebundleInitialized === 'true') return;
    root.dataset.jciWagonPrebundleInitialized = 'true';

    var buttons = Array.prototype.slice.call(root.querySelectorAll('.wb-bundle__cta'));
    var itemsWrapper = root.querySelector('[data-wb-mobile-swiper]');
    var status = root.querySelector('.wb-bundle__slider-status');
    var priceEl = root.querySelector('[data-wb-bundle-price]');
    var saveEl = root.querySelector('[data-wb-bundle-save]');
    var defaultLabel = buttons[0] ? buttons[0].textContent.trim() : '';
    var layerCdn = 'https://cdn.shopify.com/s/files/1/0561/5891/2694/files/';
    var colorLabels = ['Midnight Black', 'Moss Green', 'Mocha', 'Sand'];
    var colorLayers = {
      canopy: {
        primary: [
          layerCdn + 'canopy-left-midnight-black.png',
          layerCdn + 'canopy-left-forest-green.png',
          layerCdn + 'canopy-left-mocha.png',
          layerCdn + 'canopy-left-sand.png'
        ],
        secondary: [
          layerCdn + 'canopy-right-midnight-black.png',
          layerCdn + 'canopy-right-forest-green.png',
          layerCdn + 'canopy-right-mocha.png',
          layerCdn + 'canopy-right-sand.png'
        ]
      },
      basket: {
        primary: [
          layerCdn + 'basket-left-midnight-black.png',
          layerCdn + 'basket-left-forest-green.png',
          layerCdn + 'basket-left-mocha.png',
          layerCdn + 'basket-left-sand.png'
        ],
        secondary: [
          layerCdn + 'basket-right-midnight-black.png',
          layerCdn + 'basket-right-forest-green.png',
          layerCdn + 'basket-right-mocha.png',
          layerCdn + 'basket-right-sand.png'
        ]
      }
    };

    function setButtonsLoading(isLoading, label) {
      buttons.forEach(function(button) {
        button.classList.toggle('is-loading', isLoading);
        button.disabled = isLoading;
        if (label) button.textContent = label;
      });
    }

    function setButtonsLabel(label) {
      buttons.forEach(function(button) {
        button.textContent = label;
      });
    }

    function formatMoney(cents) {
      cents = Number(cents || 0);
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents);
      }
      return '$' + (cents / 100).toLocaleString(undefined, {
        minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
        maximumFractionDigits: 2
      });
    }

    function colorIndexFromValue(value) {
      value = String(value || '').toLowerCase();
      if (value.indexOf('black') !== -1 || value.indexOf('midnight') !== -1) return 0;
      if (value.indexOf('green') !== -1 || value.indexOf('moss') !== -1 || value.indexOf('forest') !== -1) return 1;
      if (value.indexOf('sand') !== -1) return 3;
      return 2;
    }

    function normalizeColorValue(value) {
      value = String(value || '').toLowerCase().trim();
      if (value.indexOf('black') !== -1 || value.indexOf('midnight') !== -1) return 'black';
      if (value.indexOf('green') !== -1 || value.indexOf('moss') !== -1 || value.indexOf('forest') !== -1) return 'green';
      if (value.indexOf('mocha') !== -1) return 'mocha';
      if (value.indexOf('sand') !== -1) return 'sand';
      return value;
    }

    function variantMatchesColor(variant, colorLabel) {
      if (!variant) return false;
      var expected = normalizeColorValue(colorLabel);
      var values = variant.options || [variant.option1, variant.option2, variant.option3];
      return values.some(function(value) {
        return normalizeColorValue(value) === expected;
      });
    }

    function firstAvailableVariant(product) {
      if (!product || !product.variants || !product.variants.length) return null;
      return product.variants.find(function(variant) { return variant.available; }) || product.variants[0];
    }

    function bundleProduct() {
      var productScript = root.querySelector('[data-wb-bundle-product-json]');
      if (!productScript) return null;
      try {
        return JSON.parse(productScript.textContent);
      } catch (error) {
        console.warn('Could not parse prebundle product data:', error);
        return null;
      }
    }

    function setColorLayer(item, layerName, src) {
      var layer = item.querySelector('[data-wb-color-layer="' + layerName + '"]');
      if (!layer) return;
      if (src) {
        layer.onerror = function() {
          var compositor = item.querySelector('[data-wb-item-compositor]');
          var fallback = item.querySelector('.wb-item__fallback-img');
          if (compositor) compositor.hidden = true;
          if (fallback) fallback.hidden = false;
        };
        layer.src = src;
        layer.hidden = false;
      } else {
        layer.removeAttribute('src');
        layer.hidden = true;
      }
    }

    function shouldShowSecondaryLayer(item) {
      var quantity = parseInt(item.getAttribute('data-quantity') || '1', 10);
      var label = String(item.getAttribute('data-wb-item-label') || '').toLowerCase();
      return quantity > 1 || label.indexOf('2 ') !== -1 || label.indexOf('two') !== -1 || label.indexOf('dual') !== -1;
    }

    function applyColorItem(item, colorLabel) {
      var colorType = item.getAttribute('data-wb-color-item');
      var index = colorIndexFromValue(colorLabel);
      var normalizedLabel = colorLabels[index];
      var layers = colorLayers[colorType];
      if (!layers) return;

      var compositor = item.querySelector('[data-wb-item-compositor]');
      var fallback = item.querySelector('.wb-item__fallback-img');
      if (compositor) compositor.hidden = false;
      if (fallback) fallback.hidden = true;

      setColorLayer(item, 'primary', layers.primary[index]);
      setColorLayer(item, 'secondary', shouldShowSecondaryLayer(item) ? layers.secondary[index] : '');

      item.setAttribute('data-wb-selected-color', normalizedLabel);

      var label = item.querySelector('[data-wb-color-label]');
      if (label) label.textContent = normalizedLabel;

      Array.prototype.slice.call(item.querySelectorAll('[data-wb-color-swatch]')).forEach(function(button) {
        var isSelected = colorIndexFromValue(button.getAttribute('data-color-label')) === index;
        button.classList.toggle('is-selected', isSelected);
        button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });

      updateBundlePrice();
    }

    function initColorItems() {
      Array.prototype.slice.call(root.querySelectorAll('[data-wb-color-item]')).forEach(function(item) {
        var initialColor = item.getAttribute('data-wb-initial-color') || 'Mocha';
        applyColorItem(item, initialColor);

        Array.prototype.slice.call(item.querySelectorAll('[data-wb-color-swatch]')).forEach(function(button) {
          button.addEventListener('click', function() {
            applyColorItem(item, button.getAttribute('data-color-label'));
          });
        });
      });
    }

    function initMobileSwiper() {
      if (!itemsWrapper || !status) return;

      var slides = Array.prototype.slice.call(itemsWrapper.querySelectorAll('.wb-item'));
      if (!slides.length) return;

      status.innerHTML = slides.map(function(_, index) {
        return '<button type="button" class="wb-bundle__slider-dot' + (index === 0 ? ' is-active' : '') + '" aria-label="Go to bundle item ' + (index + 1) + '"></button>';
      }).join('');

      var dots = Array.prototype.slice.call(status.querySelectorAll('.wb-bundle__slider-dot'));

      function setActiveDot() {
        if (!window.matchMedia('(max-width: 700px)').matches) return;
        var wrapperRect = itemsWrapper.getBoundingClientRect();
        var center = wrapperRect.left + wrapperRect.width / 2;
        var activeIndex = 0;
        var activeDistance = Infinity;

        slides.forEach(function(slide, index) {
          var slideRect = slide.getBoundingClientRect();
          var slideCenter = slideRect.left + slideRect.width / 2;
          var distance = Math.abs(center - slideCenter);
          if (distance < activeDistance) {
            activeDistance = distance;
            activeIndex = index;
          }
        });

        dots.forEach(function(dot, index) {
          dot.classList.toggle('is-active', index === activeIndex);
        });
      }

      dots.forEach(function(dot, index) {
        dot.addEventListener('click', function() {
          slides[index].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        });
      });

      itemsWrapper.addEventListener('scroll', function() {
        window.requestAnimationFrame(setActiveDot);
      }, { passive: true });

      window.addEventListener('resize', setActiveDot);
      setActiveDot();
    }

    function selectedColorByType(colorType) {
      var item = root.querySelector('[data-wb-color-item="' + colorType + '"]');
      return item ? item.getAttribute('data-wb-selected-color') : '';
    }

    function selectedBundleVariant(product) {
      if (!product || !product.variants || !product.variants.length) return null;

      var canopyColor = selectedColorByType('canopy');
      var basketColor = selectedColorByType('basket');
      var expected = [canopyColor, basketColor].filter(Boolean).map(normalizeColorValue);

      if (!expected.length) return firstAvailableVariant(product);

      return product.variants.find(function(variant) {
        if (!variant.available || !variant.options) return false;
        return expected.every(function(value, index) {
          return normalizeColorValue(variant.options[index]) === value;
        });
      }) || product.variants.find(function(variant) {
        if (!variant.options) return false;
        return expected.every(function(value, index) {
          return normalizeColorValue(variant.options[index]) === value;
        });
      }) || firstAvailableVariant(product);
    }

    function updateBundlePrice() {
      var product = bundleProduct();
      var variant = selectedBundleVariant(product);
      if (!variant) return;

      if (priceEl) priceEl.textContent = formatMoney(variant.price);

      var compareAt = Number(variant.compare_at_price || 0);
      var price = Number(variant.price || 0);
      if (saveEl) {
        if (compareAt > price) {
          saveEl.textContent = 'You save: ' + formatMoney(compareAt - price);
          saveEl.hidden = false;
        } else {
          saveEl.textContent = '';
          saveEl.hidden = true;
        }
      }
    }

    function getCartItems() {
      var configuredBundleProduct = bundleProduct();
      var configuredBundleVariant = selectedBundleVariant(configuredBundleProduct);
      if (configuredBundleVariant && configuredBundleVariant.id) {
        return [{ id: configuredBundleVariant.id, quantity: 1 }];
      }

      return [];
    }

    function openCartDrawer() {
      document.documentElement.dispatchEvent(
        new CustomEvent('theme:cartchanged', {
          bubbles: true,
          cancelable: false,
          detail: { openDrawer: true }
        })
      );
    }

    function addBundleToCart() {
      var cartItems = getCartItems();
      if (!cartItems.length) {
        console.warn('No bundle product variant found. Select a bundle product in the Wagon Bundle section settings.');
        return;
      }

      setButtonsLoading(true, 'Adding...');

      var cartAddUrl = window.theme && window.theme.routes && window.theme.routes.cart_add_url ? window.theme.routes.cart_add_url : '/cart/add.js';

      fetch(cartAddUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items: cartItems })
      })
      .then(function(response) {
        if (!response.ok) return response.json().then(function(error) { throw error; });
        return response.json();
      })
      .then(function() {
        openCartDrawer();
        setButtonsLabel('Added');
        setTimeout(function() {
          setButtonsLabel(defaultLabel);
        }, 1500);
      })
      .catch(function(error) {
        console.error('Bundle add to cart failed:', error);
        setButtonsLabel(error && error.description ? error.description : 'Unable to add');
        setTimeout(function() {
          setButtonsLabel(defaultLabel);
        }, 2200);
      })
      .finally(function() {
        setButtonsLoading(false);
      });
    }

    initColorItems();
    updateBundlePrice();
    initMobileSwiper();

    buttons.forEach(function(button) {
      button.addEventListener('click', addBundleToCart);
    });
  }

  function initAll(container) {
    Array.prototype.slice.call((container || document).querySelectorAll('[data-jci-wagon-prebundle]')).forEach(initPrebundle);
  }

  if (window.jciWagonPrebundleAssetLoaded) {
    initAll(document);
    return;
  }

  window.jciWagonPrebundleAssetLoaded = true;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initAll(event.target);
  });
})();
